export default __webpack_public_path__ + "6703b50e1ea80bb65f669965cfdec6b5.png";